import { useEffect } from "react";
import { useFetcher } from "react-router-dom";

import AuthorizeGate from "@/modules/authorize/gate";
import getPath from "@/modules/get-path";
import { useUnprocessedProjectProvider } from "../provider";

export const ProcessStatementForm = ({ children, statementId }) => {
  const { project, processStatements } = useUnprocessedProjectProvider();
  const fetcher = useFetcher();

  useEffect(() => {
    if (fetcher.formData) {
      processStatements([statementId]);
    }
  }, [fetcher]);

  return (
    <AuthorizeGate>
      <fetcher.Form
        method="put"
        action={getPath(project, `/statements/${statementId}/process`)}
      >
        <button type="submit" className="hover:underline">
          {children}
        </button>
      </fetcher.Form>
    </AuthorizeGate>
  );
};
